/**
 * @file
 * Set sticky footer.
 *
 * It uses vendor/sticky-footer.js script.
 */

const $footer = $('.page-footer', context);

$footer.once('sticky-footer').each((index, el) => {
  const $header = $('.page-header');
  const $main = $('.page-container');
  const $this = $(el);

  if ($header.length && $this.length && $main.length) {
    $(document).sticky_footer($header, $this, $main);
    $(window).resize(() => {
      $(document).sticky_footer($header, $this, $main);
    });
  }
});
